module.exports = __webpack_public_path__ + "img/1567973778.efcb5df3.jpg";